<template>
    <ValidationProvider 
        :name="valueOuter"
        :rules="rules"
        v-slot="{ errors }"
        slim
    >
        <v-checkbox
            v-model="innerValue"
            class="checkboxTop"
            :hide-details="hideDetails"
            :value="valueOuter"
            :alvqa="alvqa"
            @change="changeFunction($event)"
            :disabled="disabled"
            :error-messages="errors"
        >
            <template v-slot:label>
                <span class="black--text pt-1" :alvqa="alvqa + '-text'">
                    {{ label }}
                </span>
                <span class="pl-1 pr-1 pt-1">
                    <BaseTooltip v-if="iconTooltipText !== ''">
                        <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                        <template v-slot:text><span>{{ iconTooltipText }}</span></template>
                    </BaseTooltip>
                </span>
            </template>
        </v-checkbox>
    </ValidationProvider>
</template>

<script>
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "BaseCheckbox",
    components: {
        BaseTooltip
    },
    props: {
        context: String,
        label: String,
        useLabelSlot: {
            default: false,
            type: Boolean
        },
        hideDetails: {
            default: true,
            type: Boolean
        },
        iconTooltipText: {
            type: String,
            default: ''
        },
        alvqa: {
            type: String,
            default: ''
        },
        valueOuter: String,
        changeFunction: {
            type: Function,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rules: {
            type: [Object, String],
            default: ""
        },
    },
    computed: {
        innerValue: {
            get() { return this.$store.getters['get' + this.context + 'Checkbox'] },
            set(value) { this.$store.commit('set' + this.context + 'Checkbox', value) }
        }
    }
}
</script>

<style>
.v-input__slot {
    align-items:flex-start !important;
}
</style>